import { Component, ViewChild } from '@angular/core';
import {
    NavController,
    Refresher} from 'ionic-angular';

import { RodeoService } from '../../services/rodeo.service';

import { OrgStandingsPage } from "./org-standings";

import { Account } from '../../model/account';
import { OrganizationStandings } from '../../model/organizationStandings';

@Component({
    selector: 'page-standings',
    templateUrl: 'standings.html'
})
export class StandingsPage {
    @ViewChild(Refresher) refresher;
    @ViewChild('content') content;

    account: Account;
    organizationStandings: OrganizationStandings[];

    loadingData: boolean;
    errorMessage: string;

    constructor(public nav: NavController, private rodeoService: RodeoService) { }

    ionViewDidLoad() {
        this.refresher.state = 'ready';
        this.refresher._beginRefresh();
    }

    back() {
        this.nav.pop();
    }

    selectOrganization(orgStandings: OrganizationStandings) {
        console.log("sending: ", orgStandings);
        this.nav.push(OrgStandingsPage, { orgStandings: orgStandings });
    }

    search() {
        if (this.refresher.state != 'refreshing') {
            this.refresher.state = 'ready';
            this.refresher._top = this.content.contentTop + 'px';
            this.refresher._beginRefresh();
        }

        this.loadingData = true;
        this.errorMessage = null;

        this.rodeoService.getStandings()
        .then(data => {
            this.loadingData = false;
            this.organizationStandings = data as OrganizationStandings[];

            this.refresher.complete();
        }, error => { 
            console.log(error);
            this.errorMessage = "Connection Error. Please Try Again";
            this.loadingData = false;
            this.refresher.complete();
        });
    }

    doRefresh(refresher) {
        this.search();
    }
}


// WEBPACK FOOTER //
// ./src/pages/standings/standings.ts